import React from "react";
import {
  FaWhatsapp,
  FaUserCog,
  FaSearch,
  FaCheckCircle,
  FaArrowRight,
  FaArrowDown,
} from "react-icons/fa";

import "./HowItWorks.css";

function HowItWorks() {
  const steps = [
    {
      icon: <FaWhatsapp />,
      title: "Contact Us",
      description:
        "Reach us via WhatsApp, phone call, or contact form and explain your device issue.",
    },
    {
      icon: <FaUserCog />,
      title: "Technician Visits You",
      description:
        "Our certified technician comes to your home, office, or preferred location.",
    },
    {
      icon: <FaSearch />,
      title: "Device Diagnosis",
      description:
        "We inspect the device, identify the problem, and provide a clear repair solution.",
    },
    {
      icon: <FaCheckCircle />,
      title: "Repair Completed",
      description:
        "Your device is repaired on-site using quality parts and tested before delivery.",
    },
  ];

  return (
    <section className="how-it-works-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">How It Works</span>

          <h2 className="section-title">Simple & Hassle-Free Repair Process</h2>

          <p className="section-description">
            Getting your device repaired is quick and convenient. We come to you
            and complete most repairs on the same day.
          </p>
        </div>

        <div className="workflow-container">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div
                className="step-card"
                data-aos="fade-right"
                data-aos-delay={index * 200}
              >
                <span className="step-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <div className="step-icon">{step.icon}</div>

                <h4>{step.title}</h4>

                <p>{step.description}</p>
              </div>

              {index !== steps.length - 1 && (
                <div
                  className="workflow-arrow"
                  data-aos="zoom-in"
                  data-aos-delay={index * 200 + 100}
                >
                  <FaArrowRight className="arrow-desktop" />
                  <FaArrowDown className="arrow-mobile" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
